import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { TEST_RESULTS_REQUEST_LIMIT } from '../../../Constants/constants';
import { isEmpty } from '../../../Utils/helpers';
import { getTestResultsForTreeView } from '../helpers';

export function useTestPolling({
  queryGetResultsById,
  id,
  getTestResultsQueryName,
  getTestResultsQueryDataName,
  typeName,
  pendingUrlTestsRef,
  pollIntervalRef,
  onUpdateResults,
  stopCount,
  setStopCount,
}) {
  const [allTestArrived, setAllTestArrived] = useState(false);
  const [pollingError, setPollingError] = useState(null);

  const { startPolling, stopPolling } = useQuery(queryGetResultsById, {
    variables: {
      executionId: id,
      idsToInclude: (
        pendingUrlTestsRef.current?.slice(0, TEST_RESULTS_REQUEST_LIMIT) || []
      ).map((r) => r._id),
    },
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      const results = (data[getTestResultsQueryName] || []).filter(
        (r) => r[getTestResultsQueryDataName] !== null
      );

      if (isEmpty(results)) return;

      const receivedIds = results.map((r) => r._id);
      const resultsForTreeview = getTestResultsForTreeView(
        results,
        0,
        typeName
      );

      if (onUpdateResults) onUpdateResults(resultsForTreeview);

      pendingUrlTestsRef.current = pendingUrlTestsRef.current.filter(
        ({ _id }) => !receivedIds.includes(_id)
      );

      if (pendingUrlTestsRef.current.length === 0) {
        stopPolling();
        setStopCount(true);
        setAllTestArrived(true);
      }
    },
    onError: (error) => {
      setPollingError(error);
    },
  });

  useEffect(() => {
    if (stopCount) return;
    startPolling(pollIntervalRef.current);

    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling, pollIntervalRef, stopCount]);

  return { allTestArrived, pollingError, startPolling, stopPolling };
}
